import React from 'react';
import { AlertCircle } from 'lucide-react';

interface SectionErrorFallbackProps {
  section: string;
  resetError?: () => void;
}

/**
 * Section-specific error fallback component
 * Provides a user-friendly error message for section-level errors
 */
export const SectionErrorFallback: React.FC<SectionErrorFallbackProps> = ({ section, resetError }) => {
  const sectionNames: Record<string, string> = {
    'spend': 'Spend',
    'campaign-spend': 'Campaign Spend',
    'spend-insights': 'Spend Insights',
    'bubble-matrix': 'Campaign Matrix',
    'admin-fees': 'Admin Fees',
    'promo-codes': 'Promo Codes',
    'updates': 'Updates',
    'notes': 'Notes',
    'funnel': 'Funnel',
    'creators': 'Recommended Creators',
    'assets': 'Live Assets'
  };

  const sectionName = sectionNames[section] || section;

  return (
    <div className="flex items-center justify-center min-h-[400px] theme-muted p-8">
      <div className="max-w-md w-full theme-surface shadow-lg rounded-lg p-6 border theme-border text-center">
        <div className="flex items-center justify-center mb-4">
          <AlertCircle className="h-12 w-12 text-orange-500 dark:text-orange-400" />
        </div>
        <h3 className="text-lg font-medium theme-text mb-2">
          {sectionName} Section Error
        </h3>
        <p className="text-sm theme-text-muted mb-4">
          Something went wrong in the {sectionName.toLowerCase()} section. 
          The rest of the dashboard is still working.
        </p>
        {resetError && (
          <button
            onClick={resetError}
            className="bg-[var(--ring)] text-white px-4 py-2 rounded-md text-sm font-medium hover:opacity-90 active:opacity-80 focus:outline-none focus:ring-2 focus:ring-[var(--ring)] focus:ring-offset-2 transition-opacity"
          >
            Try Again
          </button>
        )}
        <p className="text-xs theme-text-muted mt-4">
          You can continue using other sections of the dashboard.
        </p>
      </div>
    </div>
  );
};

